import { useState, useCallback, useEffect } from 'react';
import { message } from 'antd';
import { pw9614Api, ExecuteParams, ExecuteResult, ClosingStatus } from '../../../services/pw9614Api';

export function usePW9614Execute() {
  const currentDate = new Date();
  const [year, setYear] = useState<number>(currentDate.getFullYear());
  const [month, setMonth] = useState<number>(currentDate.getMonth() + 1);
  const [empFrom, setEmpFrom] = useState<string>('');
  const [empTo, setEmpTo] = useState<string>('ZZZZZZZZ');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<ExecuteResult | null>(null);
  const [status, setStatus] = useState<ClosingStatus | null>(null);
  const [errors, setErrors] = useState<string[]>([]);

  const loadStatus = useCallback(async () => {
    try {
      const s = await pw9614Api.getStatus();
      setStatus(s);
    } catch {
      // Silently ignore status load failure
    }
  }, []);

  useEffect(() => {
    loadStatus();
  }, [loadStatus]);

  const execute = useCallback(async () => {
    setLoading(true);
    setErrors([]);
    setResult(null);
    try {
      const params: ExecuteParams = { year, month, empFrom, empTo };
      const res = await pw9614Api.execute(params);
      setResult(res);
      message.success(`月結完成，共處理 ${res.processed} 位員工`);
      loadStatus();
    } catch (err: any) {
      if (err.response?.status === 422 && err.response?.data?.errors) {
        const vErrs = err.response.data.errors as Array<{ field: string; message: string }>;
        setErrors(vErrs.map(e => e.message));
      } else {
        const msg = err.response?.data?.error || err.message || '執行失敗';
        setErrors([msg]);
        message.error(msg);
      }
    } finally {
      setLoading(false);
    }
  }, [year, month, empFrom, empTo, loadStatus]);

  const preview = useCallback(async () => {
    setLoading(true);
    setErrors([]);
    setResult(null);
    try {
      const params: ExecuteParams = { year, month, empFrom, empTo };
      const res = await pw9614Api.preview(params);
      setResult(res);
      message.info(`預覽完成，共 ${res.processed} 位員工`);
    } catch (err: any) {
      if (err.response?.status === 422 && err.response?.data?.errors) {
        const vErrs = err.response.data.errors as Array<{ field: string; message: string }>;
        setErrors(vErrs.map(e => e.message));
      } else {
        const msg = err.response?.data?.error || err.message || '預覽失敗';
        setErrors([msg]);
        message.error(msg);
      }
    } finally {
      setLoading(false);
    }
  }, [year, month, empFrom, empTo]);

  return {
    year, setYear,
    month, setMonth,
    empFrom, setEmpFrom,
    empTo, setEmpTo,
    loading,
    result,
    status,
    errors,
    execute,
    preview,
  };
}
